import EagleTracker from '../../components/eagle-tracker';

const EagleTrackerPage = (prop) => {
  const { eagleCount, prevEagleCount } = prop;

  return (
    <EagleTracker 
      eagleCount={eagleCount} 
      prevEagleCount={prevEagleCount} 
      canPlay={true} 
      takeoverMode={true} />
  );
};

export default EagleTrackerPage;